// extracted by mini-css-extract-plugin
module.exports = {"link-buttons":"CircleImageWithBodyBlock_link-buttons__O6Ks5"};